import { render, staticRenderFns } from "./HotSearchWords.vue?vue&type=template&id=6741c9bf&scoped=true"
import script from "./HotSearchWords.vue?vue&type=script&lang=js"
export * from "./HotSearchWords.vue?vue&type=script&lang=js"
import style0 from "./HotSearchWords.vue?vue&type=style&index=0&id=6741c9bf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6741c9bf",
  null
  
)

export default component.exports